var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3EmbeddedFloorLampOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H52v-5h-5.45a8.412 8.412 0 10-16.8 0H24v5H11V11h54v54zm-22.46-5.39V60h-8.78a4.4 4.4 0 014-4.58h.37a4.41 4.41 0 014.39 4l.02.19zm3.73-11l-.13-.13 4.25-4.24L53.22 47 49 51.28 46.69 49l-.42-.39zm-6.15-3.91h-4v-6h4v6zm-13 6.61L22.91 47l2.83-2.83L30 48.45l-.13.13-.29.29-2.46 2.44z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Embedded_floor_lamp_on.936ceeb6.svg";
export { SvgA3EmbeddedFloorLampOn as ReactComponent };